import { render, staticRenderFns } from "./preview-card.vue?vue&type=template&id=322aad70&scoped=true&"
import script from "./preview-card.vue?vue&type=script&lang=js&"
export * from "./preview-card.vue?vue&type=script&lang=js&"
import style0 from "./preview-card.vue?vue&type=style&index=0&id=322aad70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322aad70",
  null
  
)

export default component.exports